import React, { useCallback, useMemo, useRef, useState } from "react";
import { REP_IMG } from "../../../../../shared/Data/typeDirs";
import { Col, Dropdown,  Overlay, Popover, Row, Spinner, Tooltip, OverlayTrigger } from "react-bootstrap";
import { /*Button,*/  Input } from '@mui/joy'
import { Button } from 'react-bootstrap'
import np from "../../../../../shared/Images/no_photo.jpg"
import { useControl, useControlReducer } from "../../../controlContext";
import { useAppContainerContext } from "../../../../revised_components/appContainer/context";
import { ReportImage } from "../../../../../shared/Objects/newReportObjects/reportImage";
import { downloadDropboxFileToLocation } from "../../../../../services/dropboxRequests";
import { useSource, useSourceReducer } from "../../../sourceContext";
import { useUserContext } from "../../../../revised_components/contextProviders/userContext";
// import { ProgressElement } from "../../../../revised_components/progressElement";
import { useNotificationContext } from "../../../../revised_components/contextProviders/notificationContext";
// import { filesGetThumbnailBatch } from "../../../../../services/dropboxRequests";
import '../../../../../assets/css/revised_css/components/controlManagerThemes/bootstrap/report_images.css'
import { ArrowLeft, ArrowRight, File, Menu, RefreshCcw, Trash2, Copy } from "react-feather";
import { getThumbnails, requestFileFromUser, simpleUploadImage } from "../../../../../services/networkRequests";
import { IMG_SIZES } from "../../../../../shared/Data/consts";
import { useControlHeaderContext } from "../../../controlWrapperContext";
// import typeMap from "../../../../../shared/Data/typeMap";
import { genId } from "../../../../../shared/utils";
import { ProgressElement } from "../../../../revised_components/progressElement";
let dialog = null;
if (window && window.require) {
  try {
    dialog = window.require('@electron/remote').dialog;
  } catch (e) {
    dialog = null;
  }
}

// const [_no, MD, LG, _alsoNo] = IMG_SIZES
const MD = IMG_SIZES[1]
const LG = IMG_SIZES[2]
const IMG_OPTIONS = [MD, LG]

export function ReportImagesControl({ idx, name, objectMetadata, label }) {
  const { [idx]: block } = useControl()
  const { [REP_IMG]: reportImages } = block
  const { settings: { readOnly: allReadOnly, lockMap } } = useControlHeaderContext()
  const readOnly = useMemo(() => (allReadOnly || (lockMap && lockMap[block._id])), [allReadOnly, lockMap, block._id])
  const { imageMap } = useSource()
  const controlReducer = useControlReducer()
  const { user } = useUserContext()
  const sourceReducer = useSourceReducer()
  const { isDragging, setProgress, setIsDragging } = useAppContainerContext()
  const [isDraggingOverPanel, setIsDraggingOverPanel] = useState(false)
  const [mouseOverImage, setMouseOverImage] = useState({ target: false, idx: false })
  const [showPhotoOverlay, setShowPhotoOverlay] = useState(false)
  // const mouseOverRef = useRef()
  const displayNotif = useNotificationContext()
  const [deleteAttempted, setDeleteAttempted] = useState(false)
  const [loading, setLoading] = useState(false)
  let timeout_id = useRef()

  async function dropImage(evt, orderIdx) {
    evt.stopPropagation()
    evt.preventDefault()
    setLoading(true)
    setIsDraggingOverPanel(false)
    setIsDragging(false)

    if (reportImages.length >= 40) {
      displayNotif('danger', 'Maximum of 40 images per block')
      return
    }

    let data = evt.dataTransfer.getData('text')
    let maybeArray = data.split(',')

    displayNotif('info', `Adding image${maybeArray.length == 1 ? '' : 's'}...`);

    console.log('data from drop???', maybeArray)
    if (Array.isArray(maybeArray) && maybeArray.every(itm => (itm.length && itm.length <= 8))) {
      let isAlamento
      if(maybeArray[0] === 'alamento'){ 
        console.log('got dropdata for alamento', maybeArray)
        maybeArray = maybeArray.slice(1)
        isAlamento = true
      }
      await dropDBGImage(maybeArray, orderIdx, isAlamento)
    } else {
      let paths = evt.dataTransfer.files
      console.log('report-image-drop-panel', orderIdx % 2 === 1 ? 'LEFT' : 'RIGHT', ' | made paths:', paths)
      await dropLocalImage(paths, orderIdx)
    }
    setLoading(false)
    // setIsDraggingOverPanel(false)
  }

  async function dropLocalImage(paths, orderIndex) {
    let newImages = []
    displayNotif('info', `Adding image${paths.length == 1 ? '' : 's'}...`);
    for (let i_p = 0; i_p < paths.length; i_p++) {
      let res =  await simpleUploadImage(false, paths[i_p], user.token)
      let newImageId = genId()
      newImages.push(new ReportImage({
        _id: newImageId,
        _reports_v2: objectMetadata._id,
        _report_blocks: block._id,
        orderIndex: orderIndex + i_p,
        dbg_id: res.files[0].id,
        storageLocation: 'dbgallery'
      }))
      setProgress(ProgressElement(i_p+1, paths.length, `Uploading Images to DBGallery: (${i_p+1} / ${paths.length})`))
    }


    newImages = newImages.map((itm, idx) => ({ ...itm, orderIndex: `${orderIndex + idx}` }))

    controlReducer({
      idx, name, type: 'changed', update: {
        [name]: [
          ...reportImages.slice(0, orderIndex),
          ...newImages,
          ...reportImages.slice(orderIndex, reportImages.length).map((itm, idx) => ({ ...itm, orderIndex: `${idx + newImages.length + orderIndex}` }))
        ]
      }, childAction: { type: 'add_blocks', name: 'dropZone', blocks: newImages }
    })
    let thumbnailQueueItems = newImages.map(img => ({_id:img._id, dbg_id: img.dbg_id, storageLocation: 'dbgallery', thumbnailSize:'md' }))
    setProgress(ProgressElement(paths.length, paths.length, `Getting new images...`))
    let thumbRes = await getThumbnails(thumbnailQueueItems, user.token)
    let newMapImageData = {}
    for (let res of thumbRes) {
      if (res.thumbnail) newMapImageData[res.metadata.name.split('.')[0]] = res.thumbnail

    }
    console.log('updating imagemap', newMapImageData)
    sourceReducer({
      type: 'update_imageMap',
      imageData: newMapImageData,
      name: REP_IMG,
      photo_update: thumbnailQueueItems
    })
    setProgress(false)

  }

  async function dropDBGImage(dbgIdArray, orderIndex, isAlamento) {
    let newImages = []
    dbgIdArray.forEach((dbg_id, idx) => {
      newImages.push(new ReportImage({
        dbg_id,
        _reports_v2: objectMetadata._id,
        _report_blocks: block._id,
        orderIndex: `${orderIndex + idx}`,
        storageLocation: !isAlamento?'dbgallery':'alamento'
      }))
      return { dbg_id, _id: newImages[idx]._id, typeDir: REP_IMG }
    })
    // for (let img of newImages) await dataSource('remDb')[REP_IMG].put(img)
    controlReducer({
      idx, name, type: 'changed', update: {
        [name]: [
          ...reportImages.slice(0, orderIndex),
          ...newImages,
          ...reportImages.slice(orderIndex, reportImages.length).map((itm, idx) => ({ ...itm, orderIndex: `${idx + newImages.length + orderIndex}` }))
        ]
      }, childAction: { type: 'add_blocks', name: 'dropZone', blocks: newImages }
    })
    setTimeout(async ()=>{
      let thumbnailQueueItems = newImages.map(({ dbg_id, _id, thumbnailSize, storageLocation }) => ({ dbg_id, _id, thumbnailSize, storageLocation }))
      let thumbnailData = await getThumbnails(thumbnailQueueItems, user.token)
      let newMapImageData = {}
      for (let res of thumbnailData) {
        if (res.thumbnail) newMapImageData[res.metadata.name.split('.')[0]] = res.thumbnail
      }
      console.log('updating imagemap', newMapImageData)
      sourceReducer({
        type: 'update_imageMap',
        imageData: newMapImageData,
        name: REP_IMG,
        photo_update: thumbnailQueueItems
  
      })
      newImages = newImages.map((itm, idx) => ({ ...itm, orderIndex: `${orderIndex + idx}` }))
    })
    
  }

  const captionChange = useCallback((orderIndex, value) => {
    clearTimeout(timeout_id.current)
    timeout_id.current = setTimeout(() => controlReducer({
      idx, name, type: 'changed', update: {
        [name]: [
          ...reportImages.slice(0, orderIndex),
          { ...reportImages[orderIndex], content: value },
          ...reportImages.slice(orderIndex + 1, reportImages.length)
        ]
      }, childAction: { idx: orderIndex, type: 'changed', name: 'content', update: { content: value, _report_blocks: block._id, _reports_v2:objectMetadata._id } }
    }), 1000)

  }, [reportImages, controlReducer, idx, name])


  async function useDialogToUploadPhotos() {
    let res = await requestFileFromUser('.jpg,.jpeg', true)
    console.debug('got res from file select', res)
    dropLocalImage(res, 0)
  }

  function closeOverlay() {
    // console.log('closing overlay', timeout_id.current)
    // clearTimeout(timeout_id.current)
    timeout_id.current = setTimeout(() => {
      setShowPhotoOverlay(false)
      setMouseOverImage({ ...mouseOverImage, idx: false })
      setDeleteAttempted(false)
    })
  }

  let rows = []
  let images = []
  let addedLength = 0

  for (let i = 0; i < reportImages.length + addedLength; i++) {
    let imageComponent = (
      <Col
        className="report-image-col"
        key={`${reportImages[i]._id}:${i}`}
        sm={reportImages[i].thumbnailSize === 'lg' ? 12 : 6}
      >
        <div className={"report-image-container " + (reportImages[i].thumbnailSize ? reportImages[i].thumbnailSize : '')} >
          {readOnly ? [] : (
            <div className={`report-image-drop-mask`}
              onMouseLeave={() => {
                closeOverlay()
              }}
              onMouseOver={(e) => {
                e.preventDefault()
                e.stopPropagation()


                setMouseOverImage({ ...mouseOverImage, idx: i })
                setDeleteAttempted(false)
              }} >
              {loading ? (<Spinner className="report-image-load-spinner" animation="border" />) : ['left', 'right'].map(side => (
                <div key={side}
                  className={`report-image-drop-panel ${side} ${isDraggingOverPanel && (isDraggingOverPanel[1] === side) && (isDraggingOverPanel[0] === i) ? 'over' : ''}`}
                  onDragOver={evt => {
                    evt.stopPropagation()
                    evt.preventDefault()
                    // console.log('dragging over')
                    setIsDraggingOverPanel([i, side])
                  }}
                  onDragLeave={(evt) => {
                    evt.stopPropagation()
                    evt.preventDefault()
                    setIsDraggingOverPanel(false)
                  }}
                  onDrop={(evt) => dropImage(evt, side === 'right' ? i + 1 : i)}
                >
                  {side === 'right' && mouseOverImage.idx === i ? (
                    <Button key={reportImages[i]._id} variant="activated" className="report-image-hover-button" onMouseOver={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      // console.log('setting mouseover', e.currentTarget)
                      clearTimeout(timeout_id.current)
                      // timeout_id.current = setTimeout(()=>{
                      setMouseOverImage({ ...mouseOverImage, target: e.currentTarget })
                      setDeleteAttempted(false)
                      timeout_id.current = setTimeout(() => setShowPhotoOverlay(true), 100)
                      // })
                    }}
                    ><Menu /></Button>
                  ) : []}
                </div>
              ))}
            </div>
          )}
          <img
            className={"report-image " + (reportImages[i].thumbnailSize ? reportImages[i].thumbnailSize : '')}
            alt={`${REP_IMG}: #${i}`}
            src={imageMap && imageMap[reportImages[i]._id] ? `data:image/jpg;base64, ${imageMap[reportImages[i]._id]}` : np}
          />

          {readOnly ? (
            <div className="report-image-readonly-caption">
              {reportImages[i].content}
            </div>
          ) : (
            <Input
              variant="outlined"
              placeholder="Note"
              defaultValue={reportImages[i].content}
              className="report-image-input"
              onChange={evt => captionChange(i - addedLength, evt.target.value)} />
          )}
        </div>

      </Col>
    )
    if (reportImages[i].thumbnailSize === 'lg') {
      if (images.length) {
        rows.push(<Row key={rows.length} noGutters>{images}</Row>)
        images = []
      }
      rows.push(<Row key={rows.length} noGutters>{imageComponent}</Row>)
    } else {
      images.push(imageComponent)
      if (images.length === 2 || (images.length && i === reportImages.length - 1)) {
        rows.push(<Row key={rows.length} noGutters>{images}</Row>)
        images = []
      }
    }
  }


  if (!readOnly) {
    rows.push(
      <div className={`report-pre-image-box ${isDragging ? 'dragging' : ''} ${isDraggingOverPanel ? ' over' : ''}`}>
        <div className={'report-pre-image-drop-mask'}
          onDragOver={evt => {
            evt.stopPropagation()
            evt.preventDefault()
            // console.log('dragging over')
            setIsDraggingOverPanel([0])
          }}
          onDragLeave={(evt) => {
            evt.stopPropagation()
            evt.preventDefault()
            setIsDraggingOverPanel(false)
          }}
          onDrop={(evt) => dropImage(evt, 0)}
        ></div>

        <div className="g-0 report-images-empty">
          <div className="report-pre-image-text">
            {`Drag and drop photos here`}
          </div>
          <div>
            <Button
              variant="soft"
              color="primary"
              className="btn-custom-primary-soft"
              onClick={useDialogToUploadPhotos}
            >Upload photos</Button>
          </div>
        </div>
      </div>
    )
  }

  const containerClassName = useMemo(() => isDragging && !readOnly ? 'report-image-control-container dragging' : 'report-image-control-container', [isDragging, readOnly])

  return (
    <div className="report-image-outer-container">
      <div className={containerClassName}>
        <PhotoOverlay
          idx={idx}
          name={name}
          show={showPhotoOverlay}
          objectMetadata={objectMetadata}
          reportImages={reportImages}
          closeOverlay={() => {
            closeOverlay()
          }}
          mouseOverImage={mouseOverImage}
          setMouseOverImage={setMouseOverImage}
          deleteAttempted={deleteAttempted}
          setDeleteAttempted={setDeleteAttempted}
          keepOpen={() => {
            clearTimeout(timeout_id.current)
          }}
        />
        {rows}
      </div>
    </div>
  )
}


function PhotoOverlay({
  show,
  mouseOverImage,
  reportImages,
  idx,
  name,
  setMouseOverImage,
  closeOverlay,
  objectMetadata,
  deleteAttempted,
  setDeleteAttempted,
  keepOpen
}) {
  const controlReducer = useControlReducer()
  const { user } = useUserContext()
  const sourceReducer = useSourceReducer()
  const displayNotif = useNotificationContext()
  // const dirName = useMemo(()=>objectMetadata && objectMetadata.dirName, [objectMetadata])
  // const show = useMemo(() => propShow && (mouseOverImage.idx !== false), [propShow, mouseOverImage])
  function moveImage(evt) {
    let imageIndex = parseInt(evt.currentTarget.name, 10)
    let move = parseInt(evt.currentTarget.value, 10)
    console.log('moving image', imageIndex, move, imageIndex + move)
    if (reportImages.length === 1) return
    if (imageIndex >= 39 && move === 1) return
    if (imageIndex === 0 && move === -1) return
    if (imageIndex + move >= reportImages.length) return

    const swapImmutable = (array, i, j) => {
      const newArray = [...array];
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
      return newArray;
    };

    let newReportImages = swapImmutable(reportImages, imageIndex, imageIndex + move).map((itm, idx) => ({ ...itm, orderIndex: `${idx}` }))

    console.log('moved image from', imageIndex, 'to', imageIndex + move, newReportImages)
    controlReducer({
      type: 'changed',
      name,
      idx,
      update: { [name]: newReportImages },
      childAction: {
        type: 'changed',
        idx: imageIndex,
        name: 'orderIndex',
        update: {
          _id: reportImages[imageIndex]._id,
          _report_blocks: reportImages[imageIndex]._report_blocks,
          orderIndex: `${imageIndex + move}`
        }
      }
    })
    closeOverlay()
  }

  async function downloadPhoto(evt) {
    let imageIndex = evt.currentTarget.value
    let dbxPath = reportImages[imageIndex].dropboxPath

    await downloadDropboxFileToLocation(dbxPath, false, user.token)

  }


  async function uploadImageAndRefresh(evt) {
    let file = await requestFileFromUser('.jpg,.jpeg', true)
    let result = await simpleUploadImage(false, file[0], user.token)
    const newDbgId = result.files[0].id
    controlReducer({
      type: 'changed', idx, name,
      update: {
        [name]: [
          ...reportImages.slice(0, mouseOverImage.idx),
          { ...reportImages[mouseOverImage.idx], dbg_id: newDbgId },
          ...reportImages.slice(mouseOverImage.idx + 1)
        ]
      },
      childAction: {
        type: 'changed',
        idx: mouseOverImage.idx,
        name: 'dbg_id',
        update: { dbg_id: newDbgId }
      }
    })
    updateImageMap([{
      _id: reportImages[mouseOverImage.idx]._id,
      thumbnailSize: reportImages[mouseOverImage.idx].thumbnailSize,
      storageLocation: 'dbgallery',
      dbg_id: newDbgId,
    }])
  }

  async function updateImageMap(queueItems) {
    let thumbRes = await getThumbnails(queueItems, user.token)
    let newMapImageData = {}
    for (let res of thumbRes) {
      if (res.thumbnail) newMapImageData[res.metadata.name.split('.')[0]] = res.thumbnail
    }
    console.log('updating imagemap', newMapImageData)
    sourceReducer({ type: 'update_imageMap', imageData: newMapImageData, name: REP_IMG, photo_update: queueItems })
  }

  function onSelectThumbnailSize(eventKey) {
    console.log('setting new thumb size for image', eventKey, mouseOverImage.idx)
    controlReducer({
      type: 'changed', idx, name, update: {
        [name]: [
          ...reportImages.slice(0, mouseOverImage.idx),
          { ...reportImages[mouseOverImage.idx], thumbnailSize: eventKey },
          ...reportImages.slice(mouseOverImage.idx + 1)
        ]
      },
      photo_update: [generateThumbnailRequest(reportImages[mouseOverImage.idx])],
      childAction: { type: 'changed', idx: mouseOverImage.idx, name: 'thumbnailSize', update: { thumbnailSize: eventKey } }
    })
    setTimeout(() => updateImageMap([{
      _id: reportImages[mouseOverImage.idx]._id,
      thumbnailSize: eventKey,
      storageLocation: reportImages[mouseOverImage.idx].storageLocation,
      dbg_id: reportImages[mouseOverImage.idx].dbg_id,
      path: reportImages[mouseOverImage.idx].dropboxPath,
    }]))
  }

  return (
    <Overlay show={show} target={mouseOverImage.target} placement="top">
      {(props) => (
        <Popover {...props} onMouseOver={keepOpen} onMouseLeave={closeOverlay} placement="top">
          <Popover.Header>Photo Options</Popover.Header>
          <Popover.Body>
            <div>
              <Button
                variant="outline-secondary"
                name={mouseOverImage.idx || 0}
                value={-1}
                disabled={!mouseOverImage.idx}
                onClick={moveImage}>
                <ArrowLeft />
              </Button>
              <Button
                variant="outline-secondary"
                value={1}
                disabled={mouseOverImage.idx === reportImages.length - 1}
                name={mouseOverImage.idx || 0}
                onClick={moveImage}>
                <ArrowRight />
              </Button>
              <Button variant="outline-activated" value={mouseOverImage.idx} onClick={downloadPhoto}><File /></Button>
              <Button variant="outline-info" value={mouseOverImage.idx} onClick={uploadImageAndRefresh}><RefreshCcw /></Button>
              <OverlayTrigger overlay={(props)=><Tooltip {...props}>Copy DBGallery photo id to clipboard</Tooltip>}>
                <Button variant="outline-info" 
                  value={mouseOverImage.idx} 
                  onClick={()=>{
                    if(!reportImages[mouseOverImage.idx].dbg_id){
                      return displayNotif('warning', "This image is not stored on DBGallery", 5000)
                    }
                    navigator.clipboard?.writeText(reportImages[mouseOverImage.idx].dbg_id)
                    return displayNotif('success', 
                      "Image DBGallery id has been copied to your clipboard. Paste this id in the DBGallery Seach Bar to find your photo.",
                      10000
                    )
                  }}>
                  <Copy />
                </Button>
              </OverlayTrigger>

            </div>
            <div>
              <Dropdown variant="outline-info" onSelect={onSelectThumbnailSize}>
                <Dropdown.Toggle>{show ? reportImages[mouseOverImage.idx] && reportImages[mouseOverImage.idx].thumbnailSize : 'md'}</Dropdown.Toggle>
                <Dropdown.Menu>
                  {IMG_OPTIONS.map((size) => <Dropdown.Item key={size} eventKey={size}>{size}</Dropdown.Item>)}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div>
              <Button variant="outline-danger" onClick={(evt) => {
                if (deleteAttempted) {
                  setMouseOverImage({ idx: false })
                  setDeleteAttempted(false)
                  controlReducer({
                    type: 'changed', idx, name, update: {
                      [name]: [
                        ...reportImages.slice(0, mouseOverImage.idx),
                        // { ...reportImages[mouseOverImage.idx], thumbnailSize: eventKey },
                        ...reportImages.slice(mouseOverImage.idx + 1)
                      ]
                    }, childAction: { type: 'delete_block', idx: mouseOverImage.idx, name: 'overlay', file: reportImages[mouseOverImage.idx] }
                  })
                } else {
                  setDeleteAttempted(true)
                }
              }}>
                {!deleteAttempted ? (<Trash2 />) : 'Click again to delete photo'}
              </Button>
            </div>
          </Popover.Body>
        </Popover>
      )}
    </Overlay>
  )
}
function generateThumbnailRequest(image) {
  let { thumbnailSize, path, dbg_id, _id, storageLocation } = image
  if (!dbg_id) return { path, thumbnailSize }
  return {
    _id,
    dbg_id,
    thumbnailSize,
    storageLocation,
  }
}